import { Observable } from "rxjs";
import { StateService } from "./stateService";

export interface RefreshGridState {
    active: boolean
    refresh: boolean
    gridName?: string
  }

  
const initialState: RefreshGridState = {
    active: false,
    refresh: false,
    gridName: ""
}


export class RefreshGridServiceForRoot extends StateService<RefreshGridState>{
    public static service: RefreshGridServiceForRoot;
    
    public static getRefreshGridService() : RefreshGridServiceForRoot {
        if ( this.service === undefined) {
            this.service = new RefreshGridServiceForRoot();
        }
        return this.service;
    }

    private constructor() {
        super(initialState);
    }
    
    public subscription(): Observable<RefreshGridState> {
        return this.subscribe();
    }

    public reset() {
        this.changeState({active: false, refresh: false});   
    }

    public changeRefresh(gridName: string, refresh: boolean, active: boolean) : void {       
        this.changeState({gridName: gridName, refresh: refresh, active: active});        
    }

    public get refreshState(): RefreshGridState {
        return this.state;
    }
}